import { render, staticRenderFns } from "./SuspensionView.vue?vue&type=template&id=e0e416f4&scoped=true&"
import script from "./SuspensionView.vue?vue&type=script&lang=js&"
export * from "./SuspensionView.vue?vue&type=script&lang=js&"
import style0 from "./SuspensionView.vue?vue&type=style&index=0&id=e0e416f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e416f4",
  null
  
)

export default component.exports